<template>
  <div class="privacy-policy-modal" v-if="show">
    <div class="modal-overlay" @click="closeModal"></div>
    <div class="modal-container">
      <div class="modal-header">
        <h2>{{ $t('auth.privacyPolicy.title') }}</h2>
        <button class="close-button" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <div class="modal-content">
        <p class="welcome-text">
          {{ $t('auth.privacyPolicy.welcome') }}
        </p>

        <div class="policy-section">
          <h3>{{ $t('auth.privacyPolicy.section1.title') }}</h3>
          <p>{{ $t('auth.privacyPolicy.section1.description') }}</p>
          <ul>
            <li><strong>{{ $t('auth.privacyPolicy.section1.registration') }}</strong></li>
            <li>{{ $t('auth.privacyPolicy.section1.newsletters') }}</li>
            <li>{{ $t('auth.privacyPolicy.section1.communications') }}</li>
          </ul>
        </div>

        <div class="policy-section">
          <h3>{{ $t('auth.privacyPolicy.section2.title') }}</h3>
          <p>{{ $t('auth.privacyPolicy.section2.description') }}</p>
        </div>

        <div class="policy-section">
          <h3>{{ $t('auth.privacyPolicy.section3.title') }}</h3>
          <p>{{ $t('auth.privacyPolicy.section3.description') }}</p>
          <ul>
            <li>{{ $t('auth.privacyPolicy.section3.point1') }}</li>
            <li>{{ $t('auth.privacyPolicy.section3.point2') }}</li>
          </ul>
        </div>

        <div class="policy-section">
          <h3>{{ $t('auth.privacyPolicy.section4.title') }}</h3>
          <p>{{ $t('auth.privacyPolicy.section4.description') }}</p>
        </div>

        <div class="policy-section">
          <h3>{{ $t('auth.privacyPolicy.section5.title') }}</h3>
          <p>{{ $t('auth.privacyPolicy.section5.description') }}</p>
        </div>

        <div class="policy-section acceptance">
          <h3>{{ $t('auth.privacyPolicy.acceptance.title') }}</h3>
          <p>{{ $t('auth.privacyPolicy.acceptance.description') }}</p>
          <p>{{ $t('auth.privacyPolicy.acceptance.contact') }}</p>
        </div>
      </div>

      <div class="modal-footer">
        <button class="accept-button" @click="acceptAndClose">
          <i class="fas fa-check"></i> {{ $t('auth.privacyPolicy.acceptButton') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    acceptAndClose() {
      this.$emit('accept');
      this.closeModal();
    }
  }
}
</script>

<style scoped>
.privacy-policy-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: -1;
}

.modal-container {
  background: rgba(20, 20, 20, 0.95);
  border: 1px solid rgba(255, 0, 0, 0.2);
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 20px rgba(255, 0, 0, 0.2);
  animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  padding: 1.2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  color: #ff3e3e;
  margin: 0;
  font-size: 1.3rem;
  line-height: 1.3;
}

.close-button {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 1.25rem;
  cursor: pointer;
  transition: color 0.2s;
  margin-left: 0.5rem;
  flex-shrink: 0;
}

.close-button:hover {
  color: #ff3e3e;
}

.modal-content {
  padding: 1.2rem;
  overflow-y: auto;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
  font-size: 0.95rem;
}

.welcome-text {
  font-size: 1rem;
  margin-bottom: 1.2rem;
  border-left: 3px solid #ff3e3e;
  padding-left: 0.8rem;
}

.policy-section {
  margin-bottom: 1.2rem;
}

.policy-section h3 {
  color: #ff3e3e;
  margin-bottom: 0.6rem;
  font-size: 1.1rem;
}

.policy-section ul {
  margin-left: 1.2rem;
}

.policy-section li {
  margin-bottom: 0.4rem;
}

.acceptance {
  background: rgba(255, 62, 62, 0.1);
  padding: 0.8rem;
  border-radius: 4px;
  border-left: 3px solid #ff3e3e;
}

.modal-footer {
  padding: 1.2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: flex-end;
}

.accept-button {
  background: #ff3e3e;
  color: white;
  border: none;
  padding: 0.7rem 1.2rem;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.95rem;
}

.accept-button:hover {
  background: #ff2525;
}

/* Media queries for mobile optimization */
@media (max-width: 768px) {
  .modal-container {
    width: 95%;
    max-height: 85vh;
  }
  
  .modal-header h2 {
    font-size: 1.1rem;
  }
  
  .close-button {
    font-size: 1.1rem;
  }
  
  .modal-content {
    padding: 1rem;
    font-size: 0.9rem;
  }
  
  .welcome-text {
    font-size: 0.95rem;
  }
  
  .policy-section h3 {
    font-size: 1rem;
  }
  
  .accept-button {
    padding: 0.6rem 1rem;
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .privacy-policy-modal {
    padding: 0.5rem;
  }
  
  .modal-container {
    width: 100%;
    max-height: 90vh;
  }
  
  .modal-header {
    padding: 1rem 0.8rem;
  }
  
  .modal-header h2 {
    font-size: 1rem;
  }
  
  .modal-content {
    padding: 0.8rem;
    font-size: 0.85rem;
  }
  
  .welcome-text {
    font-size: 0.9rem;
    padding-left: 0.6rem;
    margin-bottom: 1rem;
  }
  
  .policy-section {
    margin-bottom: 1rem;
  }
  
  .policy-section h3 {
    font-size: 0.95rem;
    margin-bottom: 0.4rem;
  }
  
  .policy-section ul {
    margin-left: 1rem;
  }
  
  .acceptance {
    padding: 0.7rem;
  }
  
  .modal-footer {
    padding: 0.8rem;
  }
  
  .accept-button {
    padding: 0.6rem 0.8rem;
    font-size: 0.85rem;
    width: 100%;
    justify-content: center;
  }
}

@media (max-height: 600px) {
  .modal-container {
    max-height: 95vh;
  }
  
  .policy-section {
    margin-bottom: 0.8rem;
  }
  
  .modal-content {
    padding-top: 0.6rem;
    padding-bottom: 0.6rem;
  }
}
</style>
